export enum WithdrawalRequestStatusType {
    Pending = 'Pending',
    Approved = 'Approved',
    Processed = 'Processed',
    Declined = 'Declined',
    Canceled = 'Canceled',
}

export enum WithdrawalRequestPaymentMethodType {
    Crypto = 'Crypto',
    GiftCard = 'GiftCard',
    UPI = 'UPI',
    BKash = 'BKash',
    BankTransaction = 'BankTransaction',
    Other = 'Other',
}

export enum CryptoWalletNetworkType {
    TON = 'TON',
    TRON = 'TRON',
    ETH = 'ETH',
    BNB = 'BNB',
}

export enum GiftCardProviderType {
    Eneba = 'Eneba',
}

export interface WithdrawalRequestFilter {
    paymentMethod?: WithdrawalRequestPaymentMethodType;
    network?: CryptoWalletNetworkType;
    giftCardProvider?: GiftCardProviderType;
}
